<template>
    <component :is="layout">
        <router-view />
    </component>

    <div id="teleportAreaRoot"></div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import { useRoute } from 'vue-router';

export default defineComponent({
    setup()
    {
        const route = useRoute();

        /**
         * Get the layout defined for the current route.
         */
        const layout = computed(() : string => {
            return (route.meta.layout ?? 'default') + '-layout';
        });

        return { layout };
    },
})
</script>


<style lang="scss">

@import "assets/scss/app";

#app {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    overflow-x: hidden;
}

#nav {
    padding: 30px;
}

#nav a {
    font-weight: bold;
    color: #2c3e50;
}

#nav a.router-link-exact-active {
    color: #42b983;
}
</style>
